export * from './theme-color.directive';
